module.exports = require("multipipe");